import React    from 'react';
import ReactDom from 'react-dom';
import Moment   from 'moment';

import Const    from 'fw_const';
import Utils    from 'utils';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


class Navigation extends React.Component {
  render() {
    let data = this.props.data;
    if( data.userData && data.userData.is_guest == 1 ) return null;
    
    return (
      <div className="navigation">
        
        <ul>
          { this.props.menus.map((d, key) => {
            let flg = (this.props.tab == d.id) ? 'on' : 'off';
            return (
              <OverlayTrigger key={key} placement="right" delayShow={150} overlay={<Tooltip>{d.name}</Tooltip>}>
                <li className={flg} onClick={this.props.change_ev.bind(this, d.id)}><i className="material-icons">{d.icon}</i></li>
  	          </OverlayTrigger>
  	        );
          })}
        </ul>
        
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Navigation;